import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class ImageSize {
  constructor(data = {}) {
    _defineProperty(this, "height", {
      fieldName: 'height',
      content: null
    });
    _defineProperty(this, "width", {
      fieldName: 'width',
      content: null
    });
    _defineProperty(this, "path", {
      fieldName: 'path',
      content: null
    });
    let {
      path = null,
      width = null,
      height = null
    } = data !== null && data !== void 0 ? data : {};
    this.width.content = width;
    this.height.content = height;
    this.path.content = path;
  }
  getPath() {
    return this.path.content;
  }
  getWidth() {
    return this.width.content;
  }
  getHeight() {
    return this.height.content;
  }
}